import React from "react"
import { Container } from "@carrotfertility/carotene"

// @ts-expect-error TS7006
function Badge(props): JSX.Element {
  return (
    <Container sx={{ position: "relative", display: "inline-block" }}>
      {props.children}
      {props.badgeContent > 0 && (
        <Container
          background="errorRed"
          borderRadius="50%"
          padding="0"
          width="16px"
          height="16px"
          sx={{
            position: "absolute",
            color: "white",
            right: -18,
            top: -6,
            textAlign: "center",
            fontSize: "10px",
            lineHeight: 1.5,
            fontWeight: 600
          }}
        >
          {props.badgeContent}
        </Container>
      )}
    </Container>
  )
}

export default Badge
